import { Injectable } from '@angular/core';
import {
  changePasswordMutation,
  updateAddressMutation,
  updateDossierSideMenuConfigurationMutation,
  updateFullScreenModeMutation,
  updateUserMutation
} from '@app/core/data/user.mutations';
import { userQuery, usersForAgencyQuery } from '@app/core/data/user.queries';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';

@Injectable()
export class UserDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  getUser() {
    return this.graphqlService.query(userQuery);
  }

  updateUser(user: any) {
    return this.graphqlService.mutation(updateUserMutation, {user});
  }

  changePassword(changePassword: any) {
    return this.graphqlService.mutation(changePasswordMutation, {changePassword});
  }

  updateAddress(address: any) {
    return this.graphqlService.mutation(updateAddressMutation, {address});
  }

  updateFullScreenMode() {
    return this.graphqlService.mutation(updateFullScreenModeMutation, {}, hideLoader());
  }

  updateDossierSideMenuConfiguration() {
    return this.graphqlService.mutation(updateDossierSideMenuConfigurationMutation, {}, hideLoader());
  }

  getUsersForAgency(agencyId: number) {
    return this.graphqlService.query(usersForAgencyQuery, {agencyId});
  }
}
